/**
 * Dashboard actions reachable from outside the dashboard (phone bottom bar, N6).
 * Same mechanism as the shell sidebar: navigate home if needed, then scroll to
 * the section / ask the dashboard to open its statement picker.
 */
const MOUNT_DELAY_MS = 300;

function afterDashboard(onDashboard: boolean, goHome: () => void, fn: () => void): void {
  if (onDashboard) {fn(); return;}
  goHome();
  window.setTimeout(fn, MOUNT_DELAY_MS);
}

export function openDashboardSection(sectionId: string, onDashboard: boolean, goHome: () => void): void {
  afterDashboard(onDashboard, goHome, () => {
    document.getElementById(sectionId)?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  });
}

export function openStatement(onDashboard: boolean, goHome: () => void): void {
  afterDashboard(onDashboard, goHome, () => window.dispatchEvent(new CustomEvent('portal:open-statement')));
}
